import { render, staticRenderFns } from "./AvatarUploader.vue?vue&type=template&id=25f8b8f3&scoped=true"
import script from "./AvatarUploader.vue?vue&type=script&lang=js"
export * from "./AvatarUploader.vue?vue&type=script&lang=js"
import style0 from "./AvatarUploader.vue?vue&type=style&index=0&id=25f8b8f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f8b8f3",
  null
  
)

export default component.exports